import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnInit
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'portal-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss']
})
export class InputFileComponent implements OnInit{
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() text: string;
  @Input() icon: string;
  @Input() accept: string;
  @Input() disabled: string;
  @Input() loading: boolean;
  @Input() maxSize = 2500000;
  @Output() fileChange: EventEmitter<
    File | { maxSize: true }
  > = new EventEmitter(null);
  @ViewChild('inputFile', { static: true }) inputFile: ElementRef<
    HTMLInputElement
  >;
  control: AbstractControl;
  constructor() {}

  ngOnInit(): void {
    if(this.form){
      this.control=this.form.get(this.controlName)
    }
  }

  fileSelected(event: Event): void {
    const { files } = event.target as HTMLInputElement;
   if(this.form){
    if (files.length > 0) {
      const file = files[0];
      if (file.size < this.maxSize) {
        //this.fileChange.emit(file);
        this.control.setValue(file);
        this.control.markAsDirty();
      } else {
        //this.fileChange.emit({ maxSize: true });
        this.control.setErrors({fileSize:true});
      }
    }
   }else{
    if (files.length > 0) {
      const file = files[0];
      if (file.size < this.maxSize) {
        this.fileChange.emit(files[0]);
      } else {
        this.fileChange.emit({maxSize:true});
      }
    }
    
   }
    //this.inputFile.nativeElement.value = null;
  }
}
